import type { StatusPhase } from './wasserij-items';

/**
 * Filter-chip configuratie voor de /items pagina. Iedere fase mapt naar
 * één of meer Status__c picklist-waardes uit Salesforce.
 */
export const STATUS_PHASES: ReadonlyArray<{
  key: StatusPhase;
  label: string;
  statuses: ReadonlyArray<string>;
}> = [
  { key: 'opgehaald', label: 'Opgehaald', statuses: ['Opgehaald'] },
  { key: 'voorinspectie', label: 'Voorinspectie', statuses: ['Klaar voor Voorinspectie'] },
  { key: 'vriezer', label: 'In Vriezer', statuses: ['In Vriezer'] },
  { key: 'kloppen', label: 'Klaar voor Kloppen', statuses: ['Klaar voor Kloppen'] },
  { key: 'reinigen', label: 'Klaar voor Reinigen', statuses: ['Klaar voor Reinigen'] },
  { key: 'drogen', label: 'Drogen', statuses: ['Drogen'] },
  { key: 'nabehandeling', label: 'Nabehandeling', statuses: ['Randen Plakken', 'In Reparatie', 'In Nabehandeling'] },
  { key: 'ingepakt', label: 'Ingepakt', statuses: ['Ingepakt', 'Klaargelegd'] },
  { key: 'bus', label: 'In bus', statuses: ['In bus'] },
];

export const ITEM_STATUS_COLORS: Record<string, string> = {
  'Niet afgeleverd': 'bg-red-100 text-red-700',
  'Opgehaald': 'bg-blue-100 text-blue-700',
  'Geannuleerd': 'bg-slate-100 text-slate-500',
  'Klaar voor Voorinspectie': 'bg-purple-100 text-purple-700',
  'In Vriezer': 'bg-cyan-100 text-cyan-700',
  'Klaar voor Kloppen': 'bg-amber-100 text-amber-700',
  'Klaar voor Reinigen': 'bg-amber-100 text-amber-700',
  'Drogen': 'bg-orange-100 text-orange-700',
  'Randen Plakken': 'bg-pink-100 text-pink-700',
  'In Reparatie': 'bg-pink-100 text-pink-700',
  'In Nabehandeling': 'bg-pink-100 text-pink-700',
  'Ingepakt': 'bg-emerald-100 text-emerald-700',
  'Klaargelegd': 'bg-emerald-100 text-emerald-700',
  'In bus': 'bg-indigo-100 text-indigo-700',
  'Afgeleverd': 'bg-green-100 text-green-700',
};
